import React, { useState } from 'react';
import { Button, Modal } from 'antd/lib/index';
import { DeleteOutlined } from '@ant-design/icons';

import FilterContainer from '../filter/FilterContainer';
import Badge from '../shared/Badge';
import { isNotEmptyClause } from '../../utils/filter';

const FilterModal = ({
  openModal,
  closeModal,
  btnText = 'Filter',
  onRemoveFilter,
  ...restParams
}) => {
  const [opened, setOpened] = useState(false);
  const badgeCount = restParams.clauses.filter(isNotEmptyClause).length;

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Button
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 50,
        }}
        onClick={() => setOpened(true)}
      >
        {!!badgeCount && <Badge count={badgeCount} style={{ marginRight: 5 }} />}
        {btnText}
      </Button>
      <Button
        className="square-icon-button"
        onClick={onRemoveFilter}
        style={{ border: '1px solid lightgrey' }}
      >
        <DeleteOutlined />
      </Button>
      <Modal
        title={btnText}
        wrapClassName="global-filter-modal"
        open={opened}
        width={900}
        onCancel={() => setOpened(false)}
        footer={null}
      >
        <FilterContainer {...restParams} />
      </Modal>
    </div>
  );
};

export default FilterModal;
